import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from '../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../core/defaultValues';
import { ExceptionManager } from '../../../../../core/logManager';

import { resetALL } from '../../../../../.globals/redux/actions';

//STATE INITIAL
const INIT_STATE = {
    loadingFootage: {},
    footageResponse: {},
    footageError: {},

    loadingSnapshot: {},
    snapshotResponse: {},
    snapshotError: {},
};

const route = 'modules/.common/components/Video/redux/slice.js';

export const getVideoFootage = createAsyncThunk('modules/.common/components/Video/getVideoFootage', async ({ readingId, deviceId }, { rejectWithValue, dispatch }) => {
    try {
        const response = await clientQuery(
            `
            query getVideoFootage ($readingId: String!, $deviceId: String!) {
                videoFootage: getVideoFootage (readingId: $readingId, deviceId: $deviceId) {
                    id
                    deviceId
                    eventCode
                    eventName
                    thumbnailUrl
                    duration
                    mediaType
                    url
                }
            }
            `,
            {
                readingId: `${readingId}`,
                deviceId: `${deviceId}`
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        if (!response?.videoFootage) {
            throw 'video_errorApi';
        }

        return response?.videoFootage;
    } catch (exc) {
        ExceptionManager(exc, route, 'getVideoFootage');
        return rejectWithValue(exc)
    }
});

export const getVideoLastSnapshot = createAsyncThunk('modules/.common/components/Video/getVideoLastSnapshot', async ({ deviceId, unitTime }, { rejectWithValue, dispatch }) => {
    try {
        const response = await clientQuery(
            `
            query getVideoLastSnapshot ($deviceId: String!, $unitTime: AWSDateTime!) {
                snapshot: getVideoLastSnapshot (deviceId: $deviceId, unitTime: $unitTime) {
                    id
                    deviceId
                    eventCode
                    eventName
                    thumbnailUrl
                    duration
                    mediaType
                    url
                }
            }
            `,
            {
                deviceId,
                unitTime
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        if (!response?.snapshot) {
            throw 'video_snapshotErrorApi';
        }

        return response?.snapshot;
    } catch (exc) {
        ExceptionManager(exc, route, 'getVideoLastSnapshot');
        return rejectWithValue(exc)
    }
});

//Slice
const videoRedux = createSlice({
    name: 'dynamicForms/list',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE)

        builder.addCase(getVideoFootage.pending, (state, action) => {
            state.loadingFootage[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = true;
            state.footageError[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = null;
        })
        builder.addCase(getVideoFootage.fulfilled, (state, action) => {
            state.loadingFootage[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = false;
            state.footageResponse[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = action.payload;
            state.footageError[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = null;
        })
        builder.addCase(getVideoFootage.rejected, (state, action) => {
            state.loadingFootage[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = false;
            state.footageResponse[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = null;
            state.footageError[`${action?.meta?.arg?.readingId}-${action?.meta?.arg?.deviceId}`] = action.payload;
        })

        builder.addCase(getVideoLastSnapshot.pending, (state, action) => {
            state.loadingSnapshot[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = true;
            state.snapshotError[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = null;
        })
        builder.addCase(getVideoLastSnapshot.fulfilled, (state, action) => {
            state.loadingSnapshot[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = false;
            state.snapshotResponse[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = action.payload;
            state.snapshotError[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = null;
        })
        builder.addCase(getVideoLastSnapshot.rejected, (state, action) => {
            state.loadingSnapshot[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = false;
            state.snapshotResponse[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = null;
            state.snapshotError[`${action?.meta?.arg?.deviceId}-${action?.meta?.arg?.unitTime}`] = action.payload;
        })
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = videoRedux;

// Extract and export each action creator by name
export const { reset } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;